import { render, staticRenderFns } from "./usTaxConfirmation.vue?vue&type=template&id=af3ac816&scoped=true"
import script from "./usTaxConfirmation.vue?vue&type=script&lang=js"
export * from "./usTaxConfirmation.vue?vue&type=script&lang=js"
import style0 from "./usTaxConfirmation.vue?vue&type=style&index=0&id=af3ac816&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3ac816",
  null
  
)

export default component.exports